export const CONEXAO_ONLINE = 'CONEXAO_ONLINE'
export const CONEXAO_OFFLINE = 'CONEXAO_OFFLINE'

export const setOnline = () => ({ type: CONEXAO_ONLINE })
export const setOffline = () => ({ type: CONEXAO_OFFLINE })
